export default "__VITE_ASSET__86794beb__"